interface IFilterRange {
  min: number;
  max: number;
}

// 필터 숏컷 URL 생성 유틸리티 함수
export const createFilterShortcutUrl = (
  pagePath: string,
  params: {
    sort?: string;
    brand?: string;
    psRange?: IFilterRange;
    priceRange?: IFilterRange;
  },
) => {
  const queryParams: string[] = [];

  if (params.sort) {
    queryParams.push(`sort=${params.sort}`);
  }

  if (params.brand) {
    queryParams.push(`brand=${params.brand}`);
  }

  if (params.psRange) {
    const { min, max } = params.psRange;
    queryParams.push(`minEngineOutputPs=${min}`);
    queryParams.push(`maxEngineOutputPs=${max}`);
  }

  if (params.priceRange) {
    const { min, max } = params.priceRange;
    queryParams.push(`minMedianPrice=${min}`);
    queryParams.push(`maxMedianPrice=${max}`);
  }

  const queryString = queryParams.join('&');
  return queryString ? `${pagePath}?${queryString}` : pagePath;
};
